import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetNetworksPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/inputs/get-networks-paginated.form-default-values';
import { GetNetworksPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/inputs/get-networks-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterSearchNetworkListContextProvider,
  useNetworkListContext,
} from '../network.context';
import { NetworkListFilterSearchFormController } from './network-list-filter-search-form/network-list-filter-search-form.controller';

interface NetworkListFilterSearchControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const NetworkListFilterSearchController = ({
  onCancel,
  onSuccess,
}: NetworkListFilterSearchControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useNetworkListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetNetworksPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.network-list-filter-search.error', { error: t('global.unknown') }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetNetworksPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        textToSearch: fieldValues.textToSearch,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetNetworksPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterSearchNetworkListContextProvider data={data}>
      <NetworkListFilterSearchFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterSearchNetworkListContextProvider>
  );
};
